import Swal from 'sweetalert2';

let messageErrorDefault = "Não conseguimos processar o pedido, tente novamente mais tarde!";
let messageWarningDefault = "Ufaaa! Não apagamos nada.";
let timerDefault = 5000;
let messageSuccess = 'Gravado com sucesso!';

/**
 *
 * @param message {string}
 * @param type {string}
 * @param position {string}
 * @param timer {number}
 */
window.swallCustom = (message, type, position, timer = timerDefault) => {
    Swal.fire({
        position: position,
        icon: type,
        title: message,
        showConfirmButton: true,
        timer: timer
    })
};

window.toastInfo = (message = messageWarningDefault, position = "top-end", timer = timerDefault) => {
    const messageInfo = Swal.mixin({
        toast: true,
        position: position,
        showConfirmButton: true,
        timer: timer,
    });

    messageInfo.fire({
        icon: "info",
        title: message
    });
};

window.toastMessage = (message, type = "info", position = "top-end", timer = timerDefault) => {
    const swallMessage = Swal.mixin({
        toast: true,
        position: position,
        showConfirmButton: true,
        timer: timer,
    });

    swallMessage.fire({
        icon: type,
        title: message
    });
};

/**
 *
 * @param message {string}
 * @param timer {number}
 */
window.toastSuccess = (message = messageSuccess, timer = timerDefault) => {
    const success = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: true,
        timer: timer,
        icon: 'success'
    });

    success.fire({
        title: message
    });
};

window.toastError = (message = messageErrorDefault, timer = timerDefault) => {
    const messageError = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: true,
        timer: timer,
    });

    messageError.fire({
        icon: 'error',
        title: message
    });
};

window.toastWarning = (message = messageWarningDefault, timer = timerDefault) => {
    const warning = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: true,
        timer: timer,
    });

    warning.fire({
        icon: 'warning',
        title: message
    });
};

window.alertErrorDatatable = (message = messageErrorDefault, timer = timerDefault) => {
    const errorDatatable = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: true,
        timer: timer
    });

    errorDatatable.fire({
        icon: "error",
        title: message
    });
};

window.alertConfirm = ({
                           url,
                           message = "Tem certeza que deseja apagar este item?",
                           nameUser = null,
                           messageError = false,
                           cbOnSuccess = null,
                           confirmButtonText = 'Apagar',
                           cancelButtonText = 'Cancelar',
                           messageOnCancel = "Ufaaa! Não apagamos nada.",
                           html = null
                       }) => {

    const swallWithBootstrapButtons = Swal.mixin({
        buttonsStyling: true
    });

    if (nameUser === null) {
        nameUser = userAuth.name;
    }

    const defaultHtml = `<b>${nameUser}!</b><br/> ${message}`;

    return new Promise((resolve, reject) => {
        swallWithBootstrapButtons.fire({
            html: html || defaultHtml,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText,
            cancelButtonText,
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                if (cbOnSuccess && typeof cbOnSuccess === 'function') {
                    cbOnSuccess();
                } else {
                    axios.delete(url).then(response => {
                        toastSuccess('Apagado com sucesso!');
                        resolve('confirm')
                    }).catch(error => {
                        if (messageError) {
                            toastError();
                        }
                        console.error('alert confirm: ', error)
                        reject(error)
                    });
                }

            } else if (result.dismiss === Swal.DismissReason.cancel) {
                toastInfo(messageOnCancel);
                resolve('cancel')
            }
        }).catch(error => {
            if (messageError) {
                toastError();
            }
            console.error('alert confirm: ', error)
            reject(error)
        });
    })
}

window.Swal = Swal;